<template>
  <div class="role">
    <div class="controls">
      <div class="add">
        <el-button
          v-if="$hasPermission('roleCreate')"
          type="success"
          icon="el-icon-plus"
          circle
          @click="$router.push({ name: 'rolesAdd' })"
        />
      </div>
    </div>

    <div class="roles-list">
      <el-table
        v-if="roles"
        :data="roles"
        style="width: 100%; margin-top: 20px;"
      >
        <el-table-column
          prop="name"
          label="角色"
          min-width="200"
        />
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="$hasPermission('roleEdit')"
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'roleEdit',
                  params: { roleId: scope.row.id }
                })
              "
            >
              编辑
            </el-button>

            <el-button
              size="small"
              type="text"
              @click="
                $router.push({
                  name: 'rolePreview',
                  params: { roleId: scope.row.id }
                })
              "
            >
              预览
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div
        v-else
        class="none"
      >
        <p>暂无角色数据</p>
      </div>
    </div>
  </div>
</template>
<style lang="less">
.none {
  text-align: center;
  line-height: 30px;
  color: #333;
}
</style>
<script>
const debug = require('debug')('ccs:ctrl:role');
import axios from 'axios';

export default {
	data() {
		return {
			roles: []
		};
	},
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: 'init'
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			const roles = await axios.get('/api/roles');
			this.roles = roles;
		}
	}
};
</script>